(function () {
  'use strict';

  var L = window._pimHero || {};
  function t(key) {
    var v = L[key];
    return (typeof v === 'string' && v !== '') ? v : key;
  }
  var IMG = window._pimImages || {};
  function img(file) {
    var v = IMG[file];
    return (typeof v === 'string' && v !== '') ? v : file;
  }
  function imgUrl(file) { return "url('" + img(file) + "')"; }

  function run() {

  (function () {

    document.querySelectorAll('.pim-img-cell').forEach(function (cell) {
      var thumb = cell.querySelector('.pim-thumb-main');
      cell.querySelectorAll('.pim-hover-thumb').forEach(function (th) {
        th.addEventListener('click', function (e) {
          e.stopPropagation();
          if (thumb) thumb.style.backgroundImage = th.style.backgroundImage;
          cell.querySelectorAll('.pim-hover-thumb').forEach(function (x) { x.classList.remove('pim-hover-thumb--active'); });
          th.classList.add('pim-hover-thumb--active');
        });
      });
    });

    var selected = new Set();
    var bulkOpen = false;
    var timers = [];
    var typingTimer = null;
    var AI_TEXT = t('tour_ai_typewriter');

    function addTimer(fn, delay) { var t2 = setTimeout(fn, delay); timers.push(t2); return t2; }
    function clearTimers() { timers.forEach(clearTimeout); timers = []; }

    function startAIType(targetId) {
      var el = document.getElementById(targetId);
      if (!el) return;
      el.textContent = '';
      el.classList.add('has-cursor');
      var i = 0;
      typingTimer = setInterval(function () {
        if (i < AI_TEXT.length) { el.textContent += AI_TEXT[i++]; }
        else { clearInterval(typingTimer); typingTimer = null; }
      }, 18);
    }

    function updateBulkBar() {
      var n = selected.size;
      var bar = document.getElementById('pim-bulk-bar');
      var cnt = document.getElementById('pim-bulk-count');
      if (bar) bar.classList.toggle('is-visible', n > 0);
      if (cnt) cnt.textContent = n;
    }

    document.addEventListener('click', function (e) {
      var tg = e.target;

      if (tg.closest('#pim-bulk-btn')) {
        e.stopPropagation();
        bulkOpen = !bulkOpen;
        var dd = document.getElementById('pim-bulk-dropdown');
        var btn = document.getElementById('pim-bulk-btn');
        if (dd) dd.classList.toggle('is-open', bulkOpen);
        if (btn) btn.classList.toggle('is-open', bulkOpen);
        return;
      }
      if (bulkOpen && !tg.closest('#pim-bulk-dropdown') && !tg.closest('#pim-bulk-btn')) {
        bulkOpen = false;
        var dd2 = document.getElementById('pim-bulk-dropdown');
        var btn2 = document.getElementById('pim-bulk-btn');
        if (dd2) dd2.classList.remove('is-open');
        if (btn2) btn2.classList.remove('is-open');
      }

      var r = tg.closest('.pim-row');
      var explorer = document.getElementById('pim-explorer');
      if (r && explorer && explorer.contains(r)) {
        e.stopPropagation();
        var id = r.dataset.id;
        if (selected.has(id)) { selected.delete(id); r.classList.remove('pim-row--selected'); }
        else { selected.add(id); r.classList.add('pim-row--selected'); }
        updateBulkBar();
        var hint = document.getElementById('pim-explorer-hint'); if (hint) hint.classList.remove('is-visible');
        return;
      }
    });

    var INTRO_DURATION  = 5800;
    var SLIDE_DURATIONS = [5500, 7000, 5500, 7000];
    var currentSlide = 0;
    var slideTimer = null;

    function getSlide(n) { return document.getElementById('pim-slide-' + n); }

    function setProgress(pct, duration) {
      var fill = document.getElementById('pim-progress-fill');
      if (!fill) return;
      fill.style.transition = 'width ' + (duration / 1000) + 's linear';
      fill.style.width = pct + '%';
    }

    function showSlide(n) {
      var prev = document.querySelector('.pim-slide.is-active');
      if (prev) { prev.classList.add('is-exiting'); setTimeout(function () { prev.classList.remove('is-active', 'is-exiting'); }, 350); }

      currentSlide = n;
      var next = getSlide(n);
      if (!next) return;
      setTimeout(function () { next.classList.add('is-active'); runSlideAnimation(n); }, 60);
    }

    function advanceSlide() {
      if (currentSlide < 5) showSlide(currentSlide + 1);
    }

    function scheduleAdvance(duration) {
      if (slideTimer) clearTimeout(slideTimer);
      slideTimer = setTimeout(advanceSlide, duration);
    }

    function runSlideAnimation(n) {
      if (n === 0) {
        var pf0 = document.getElementById('pim-progress-fill');
        if (pf0) { pf0.style.transition = 'none'; pf0.style.width = '0%'; }
        [4, 3, 2, 1, 0].forEach(function (num, i) {
          addTimer(function () {
            var el = document.getElementById('pim-countdown-num');
            if (el) { el.textContent = num; el.classList.remove('is-tick'); void el.offsetWidth; el.classList.add('is-tick'); }
          }, (i + 1) * 1000);
        });
        scheduleAdvance(INTRO_DURATION);
      }

      if (n === 1) {
        var langs = [
          { fill: 'pim-lang-nl', pct: 'pim-lpct-nl', val: 100, cls: 'pim-lang-pct--full' },
          { fill: 'pim-lang-en', pct: 'pim-lpct-en', val: 100, cls: 'pim-lang-pct--full' },
          { fill: 'pim-lang-de', pct: 'pim-lpct-de', val: 88,  cls: 'pim-lang-pct--partial' },
          { fill: 'pim-lang-fr', pct: 'pim-lpct-fr', val: 45,  cls: 'pim-lang-pct--low' }
        ];
        var delay = 300;
        langs.forEach(function (l) {
          addTimer(function () {
            var f = document.getElementById(l.fill);
            var p = document.getElementById(l.pct);
            if (f) f.style.width = l.val + '%';
            if (p) { p.textContent = l.val + '%'; }
            if (l.fill === 'pim-lang-fr') {
              addTimer(function () {
                if (f) { f.className = f.className.replace('pim-lang-fill--low', 'pim-lang-fill--full'); f.style.width = '100%'; }
                if (p) { p.textContent = '100%'; p.className = p.className.replace('pim-lang-pct--low', 'pim-lang-pct--full'); }
              }, 2400);
            }
          }, delay);
          delay += 250;
        });
        setProgress(25, SLIDE_DURATIONS[0]);
        scheduleAdvance(SLIDE_DURATIONS[0]);
      }

      if (n === 2) {
        var typing = document.getElementById('pim-ai-typing');
        var slideText = document.getElementById('pim-slide-ai-text');
        if (typing) typing.style.display = 'flex';
        if (slideText) { slideText.textContent = ''; slideText.classList.remove('has-cursor'); }

        addTimer(function () {
          if (typing) typing.style.display = 'none';
          if (slideText) startAIType('pim-slide-ai-text');
          addTimer(function () {
            var fill = document.getElementById('pim-ai-complete-fill');
            var pct = document.getElementById('pim-ai-complete-pct');
            if (fill) fill.style.width = '98%';
            if (pct) pct.textContent = '98%';
          }, 2000);
        }, 1200);

        setProgress(50, SLIDE_DURATIONS[1]);
        scheduleAdvance(SLIDE_DURATIONS[1]);
      }

      if (n === 3) {
        var varData = [
          { id:'pim-vs-0', img: imgUrl('rf-red-200.jpg'),       sku:'RF-1001-R',  label: t('tour_variant_red') },
          { id:'pim-vs-1', img: imgUrl('rf-white-200.jpg'),     sku:'RF-1001-W',  label: t('tour_variant_white') },
          { id:'pim-vs-2', img: imgUrl('rf-blue-200.jpg'),      sku:'RF-1001-B',  label: t('tour_variant_blue') },
          { id:'pim-vs-3', img: imgUrl('rf-dark-blue-200.jpg'), sku:'RF-1001-DB', label: t('tour_variant_dark_blue') }
        ];

        varData.forEach(function (v, i) {
          addTimer(function () {
            var el = document.getElementById(v.id);
            if (el) el.classList.add('is-visible');
          }, 400 + i * 280);
        });

        var cycleOrder = [1, 2, 3, 0];
        cycleOrder.forEach(function (idx, i) {
          addTimer(function () {
            var v = varData[idx];
            varData.forEach(function (d) { var s = document.getElementById(d.id); if (s) s.classList.remove('pim-var-swatch--active'); });
            var active = document.getElementById(v.id); if (active) active.classList.add('pim-var-swatch--active');
            var thumb = document.getElementById('pim-var-thumb'); if (thumb) thumb.style.backgroundImage = v.img;
            var sku = document.getElementById('pim-var-sku'); if (sku) sku.textContent = v.sku;
            var label = document.getElementById('pim-var-label'); if (label) label.textContent = v.label;
          }, 1800 + i * 1700);
        });

        setProgress(75, SLIDE_DURATIONS[2]);
        scheduleAdvance(SLIDE_DURATIONS[2]);
      }

      if (n === 4) {
        var counts = [
          t('tour_bulk_count_1'),
          t('tour_bulk_count_2'),
          t('tour_bulk_count_3')
        ];

        addTimer(function () {
          var r = document.getElementById('pim-bv-1'); if (r) r.classList.add('selected');
          var cb = document.getElementById('pim-bv-count-bar'); if (cb) cb.classList.add('is-visible');
          var ct = document.getElementById('pim-bv-count-text'); if (ct) ct.textContent = counts[0];
          var panel = document.getElementById('pim-bv-actions-panel'); if (panel) panel.classList.add('is-visible');
        }, 500);

        addTimer(function () {
          var r = document.getElementById('pim-bv-2'); if (r) r.classList.add('selected');
          var ct = document.getElementById('pim-bv-count-text'); if (ct) ct.textContent = counts[1];
        }, 1100);

        addTimer(function () {
          var r = document.getElementById('pim-bv-3'); if (r) r.classList.add('selected');
          var ct = document.getElementById('pim-bv-count-text'); if (ct) ct.textContent = counts[2];
        }, 1700);

        addTimer(function () {
          var panel = document.getElementById('pim-bv-actions-panel'); if (panel) panel.classList.remove('is-visible');
        }, 3000);

        addTimer(function () { var s = document.getElementById('pim-bv-spin-1'); if (s) s.classList.add('is-visible'); }, 3600);
        addTimer(function () { var s = document.getElementById('pim-bv-spin-2'); if (s) s.classList.add('is-visible'); }, 3700);
        addTimer(function () { var s = document.getElementById('pim-bv-spin-3'); if (s) s.classList.add('is-visible'); }, 3800);

        [1, 2, 3].forEach(function (i) {
          addTimer(function () {
            var spin = document.getElementById('pim-bv-spin-' + i); if (spin) spin.classList.remove('is-visible');
            var done = document.getElementById('pim-bv-done-' + i); if (done) done.classList.add('is-visible');
          }, 5000 + (i - 1) * 180);
        });

        setProgress(100, SLIDE_DURATIONS[3]);
        scheduleAdvance(SLIDE_DURATIONS[3]);
      }

      var nextBtn = document.getElementById('pim-tour-next');
      var prevBtn = document.getElementById('pim-tour-prev');
      if (nextBtn) nextBtn.classList.toggle('is-hidden', n === 0 || n === 5);
      if (prevBtn) prevBtn.classList.toggle('is-hidden', n === 0 || n === 1);

      if (n === 5) {
        var fill2 = document.getElementById('pim-progress-fill');
        if (fill2) { fill2.style.transition = 'none'; fill2.style.width = '100%'; }
        if (slideTimer) clearTimeout(slideTimer);
        slideTimer = setTimeout(enterExplorer, 10000);
      }
    }

    function resetTour() {
      clearTimers();
      if (slideTimer) clearTimeout(slideTimer);
      if (typingTimer) { clearInterval(typingTimer); typingTimer = null; }

      var langIds = ['pim-lang-nl','pim-lang-en','pim-lang-de','pim-lang-fr'];
      langIds.forEach(function (id) { var el = document.getElementById(id); if (el) el.style.width = '0%'; });
      ['pim-lpct-nl','pim-lpct-en','pim-lpct-de','pim-lpct-fr'].forEach(function (id) { var el = document.getElementById(id); if (el) el.textContent = '0%'; });
      var fr = document.getElementById('pim-lang-fr'); if (fr) { fr.className = fr.className.replace('pim-lang-fill--full','pim-lang-fill--low'); fr.style.width='0%'; }
      var frp = document.getElementById('pim-lpct-fr'); if (frp) { frp.className = frp.className.replace('pim-lang-pct--full','pim-lang-pct--low'); frp.textContent='0%'; }

      var sText = document.getElementById('pim-slide-ai-text'); if (sText) { sText.textContent=''; sText.classList.remove('has-cursor'); }
      var typing = document.getElementById('pim-ai-typing'); if (typing) typing.style.display='flex';
      var cFill = document.getElementById('pim-ai-complete-fill'); if (cFill) cFill.style.width='72%';
      var cPct = document.getElementById('pim-ai-complete-pct'); if (cPct) cPct.textContent='72%';

      ['pim-bv-1','pim-bv-2','pim-bv-3'].forEach(function (id) { var el = document.getElementById(id); if (el) el.classList.remove('selected','done'); });
      var bvPanel = document.getElementById('pim-bv-actions-panel'); if (bvPanel) bvPanel.classList.remove('is-visible');
      var bvCb = document.getElementById('pim-bv-count-bar'); if (bvCb) bvCb.classList.remove('is-visible');
      [1,2,3].forEach(function (i) {
        var spin = document.getElementById('pim-bv-spin-' + i); if (spin) spin.classList.remove('is-visible');
        var done = document.getElementById('pim-bv-done-' + i); if (done) done.classList.remove('is-visible');
      });

      ['pim-vs-0','pim-vs-1','pim-vs-2','pim-vs-3'].forEach(function (id) { var el = document.getElementById(id); if (el) { el.classList.remove('is-visible','pim-var-swatch--active'); } });
      var vs0 = document.getElementById('pim-vs-0'); if (vs0) vs0.classList.add('pim-var-swatch--active');
      var vThumb = document.getElementById('pim-var-thumb'); if (vThumb) vThumb.style.backgroundImage = imgUrl('rf-red-200.jpg');
      var vSku = document.getElementById('pim-var-sku'); if (vSku) vSku.textContent = 'RF-1001-R';
      var vLabel = document.getElementById('pim-var-label'); if (vLabel) vLabel.textContent = t('tour_variant_red');

      var pf = document.getElementById('pim-progress-fill'); if (pf) { pf.style.transition='none'; pf.style.width='0%'; }
      var cdn = document.getElementById('pim-countdown-num'); if (cdn) cdn.textContent = '5';

      document.querySelectorAll('.pim-slide').forEach(function (s) { s.classList.remove('is-active','is-exiting'); });
    }

    function startTour() {
      resetTour();
      var tour = document.getElementById('pim-tour');
      if (tour) { tour.style.display = ''; tour.style.opacity = ''; tour.style.pointerEvents = ''; tour.classList.add('is-active'); }
      setBarMode('tour');
      selected.clear(); updateBulkBar();
      var hint = document.getElementById('pim-explorer-hint'); if (hint) hint.classList.remove('is-visible');
      addTimer(function () { showSlide(0); }, 200);
    }

    function setBarMode(mode) {
      var tourControls = document.getElementById('pim-tour-controls');
      var replayBtn = document.getElementById('pim-replay-btn');
      var nextBtn = document.getElementById('pim-tour-next');
      if (mode === 'tour') {
        if (tourControls) tourControls.style.display = 'flex';
        if (replayBtn) replayBtn.classList.remove('is-visible');
        if (nextBtn) nextBtn.classList.add('is-hidden');
        var prevBtnBar = document.getElementById('pim-tour-prev');
        if (prevBtnBar) prevBtnBar.classList.add('is-hidden');
      } else {
        if (tourControls) tourControls.style.display = 'none';
        if (replayBtn) { replayBtn.classList.add('is-visible'); replayBtn.classList.add('pulse'); setTimeout(function () { replayBtn.classList.remove('pulse'); }, 1200); }
      }
    }

    function enterExplorer() {
      var tour = document.getElementById('pim-tour');
      if (tour) {
        tour.style.pointerEvents = 'none';
        tour.style.opacity = '0';
        setTimeout(function () {
          tour.classList.remove('is-active');
          tour.style.display = 'none';
        }, 400);
      }
      setBarMode('explorer');
      var hint = document.getElementById('pim-explorer-hint');
      if (hint) { hint.classList.add('is-visible'); setTimeout(function () { hint.classList.remove('is-visible'); }, 4000); }
    }

    var skipBtn = document.getElementById('pim-tour-skip');
    if (skipBtn) skipBtn.addEventListener('click', function () { clearTimers(); if (slideTimer) clearTimeout(slideTimer); enterExplorer(); });

    var nextBtn3 = document.getElementById('pim-tour-next');
    if (nextBtn3) nextBtn3.addEventListener('click', function () {
      clearTimers(); if (slideTimer) clearTimeout(slideTimer);
      if (currentSlide < 5) showSlide(currentSlide + 1);
      else enterExplorer();
    });

    var prevBtn3 = document.getElementById('pim-tour-prev');
    if (prevBtn3) prevBtn3.addEventListener('click', function () {
      clearTimers(); if (slideTimer) clearTimeout(slideTimer);
      if (currentSlide > 1) showSlide(currentSlide - 1);
      else if (currentSlide === 1) showSlide(0);
    });

    var exploreBtn = document.getElementById('pim-explore-btn');
    if (exploreBtn) exploreBtn.addEventListener('click', function () { enterExplorer(); });

    var replayBtn = document.getElementById('pim-replay-btn');
    if (replayBtn) replayBtn.addEventListener('click', function () { startTour(); });

    var widget = document.getElementById('pim-widget');
    if (widget && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { startTour(); }
          else {
            clearTimers();
            if (slideTimer) clearTimeout(slideTimer);
            if (typingTimer) { clearInterval(typingTimer); typingTimer = null; }
          }
        });
      }, { threshold: window.innerWidth < 768 ? 0.6 : 0.3 });
      obs.observe(widget);
    } else {
      startTour();
    }

  })();

  (function () {
    var panel = document.getElementById('pim-filter-panel');
    if (!panel) return;

    var rowsWrap = document.getElementById('pim-rows');
    var rows = Array.prototype.slice.call(rowsWrap.querySelectorAll('.pim-row'));

    var PROPS = [
      { key:'name',     label: t('fp_prop_name'),     type:'text' },
      { key:'sku',      label: t('fp_prop_sku'),      type:'text' },
      { key:'complete', label: t('fp_prop_complete'), type:'enum',
        options:[
          { v:'full',    l: t('fp_enum_full') },
          { v:'partial', l: t('fp_enum_partial') },
          { v:'low',     l: t('fp_enum_low') }
        ] }
    ];
    var OPS = {
      text:[
        { op:'contains', l: t('fp_op_contains'), val:true  },
        { op:'eq',       l: t('fp_op_eq'),       val:true  },
        { op:'neq',      l: t('fp_op_neq'),      val:true  },
        { op:'has',      l: t('fp_op_has'),      val:false },
        { op:'empty',    l: t('fp_op_empty'),    val:false }
      ],
      enum:[
        { op:'eq',    l: t('fp_op_eq'),    val:true  },
        { op:'neq',   l: t('fp_op_neq'),   val:true  },
        { op:'has',   l: t('fp_op_has'),   val:false },
        { op:'empty', l: t('fp_op_empty'), val:false }
      ]
    };

    var conditions = [];
    var searchTerm = '';

    var elProp    = document.getElementById('pim-fp-prop');
    var elOp      = document.getElementById('pim-fp-op');
    var elValWrap = document.getElementById('pim-fp-value-wrap');
    var elAdd     = document.getElementById('pim-fp-add');
    var elChips   = document.getElementById('pim-fp-chips');
    var elCount   = document.getElementById('pim-fp-count');
    var elSearch  = document.getElementById('pim-fp-search');
    var elSearchX = document.getElementById('pim-fp-search-x');
    var elSavedRow  = document.getElementById('pim-fp-saved-row');
    var elSavedList = document.getElementById('pim-fp-saved-list');
    var elSaveRow   = document.getElementById('pim-fp-save-row');
    var elSaveName  = document.getElementById('pim-fp-save-name');

    var savedFilters = [];
    var savedSeq = 0;
    var activeSavedId = null;
    var lastVisible = 0;

    function propByKey(k) { return PROPS.filter(function (p) { return p.key === k; })[0]; }
    function opByKey(type, k) { return OPS[type].filter(function (o) { return o.op === k; })[0]; }
    function opLabel(type, k) { var o = opByKey(type, k); return o ? o.l : k; }
    function escapeHtml(s) { return String(s).replace(/[&<>"]/g, function (c) { return ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;' })[c]; }); }

    PROPS.forEach(function (p) {
      var o = document.createElement('option');
      o.value = p.key; o.textContent = p.label; elProp.appendChild(o);
    });

    function populateOps() {
      var p = propByKey(elProp.value);
      elOp.innerHTML = '';
      OPS[p.type].forEach(function (o) {
        var op = document.createElement('option');
        op.value = o.op; op.textContent = o.l; elOp.appendChild(op);
      });
      renderValue();
    }

    function renderValue() {
      var p = propByKey(elProp.value);
      var o = opByKey(p.type, elOp.value);
      elValWrap.innerHTML = '';
      if (!o || !o.val) return;
      if (p.type === 'enum') {
        var sel = document.createElement('select');
        sel.className = 'pim-fp__ctrl'; sel.id = 'pim-fp-value'; sel.setAttribute('aria-label', t('fp_value_aria'));
        p.options.forEach(function (opt) {
          var oo = document.createElement('option');
          oo.value = opt.v; oo.textContent = opt.l; sel.appendChild(oo);
        });
        elValWrap.appendChild(sel);
      } else {
        var inp = document.createElement('input');
        inp.className = 'pim-fp__ctrl'; inp.id = 'pim-fp-value'; inp.type = 'text';
        inp.placeholder = t('fp_value_placeholder'); inp.setAttribute('autocomplete', 'off');
        inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); addCondition(); } });
        elValWrap.appendChild(inp);
      }
    }

    function valueDisplay(p, o) {
      if (!o.val) return '';
      var ve = document.getElementById('pim-fp-value');
      if (!ve) return '';
      if (p.type === 'enum') {
        var opt = p.options.filter(function (x) { return x.v === ve.value; })[0];
        return opt ? opt.l : ve.value;
      }
      return ve.value;
    }

    function addCondition() {
      var p = propByKey(elProp.value);
      var o = opByKey(p.type, elOp.value);
      var raw = '';
      if (o.val) {
        var ve = document.getElementById('pim-fp-value');
        raw = ve ? (p.type === 'enum' ? ve.value : ve.value.trim()) : '';
        if (p.type === 'text' && !raw) { if (ve) ve.focus(); return; }
      }
      conditions.push({
        prop:p.key, op:o.op, value:raw, valueDisp:valueDisplay(p, o),
        hasVal:o.val, join: conditions.length ? 'or' : null
      });
      var ve2 = document.getElementById('pim-fp-value');
      if (ve2 && p.type === 'text') ve2.value = '';
      activeSavedId = null;
      renderChips(); renderSaved(); apply();
    }

    function renderChips() {
      elChips.innerHTML = '';
      conditions.forEach(function (c, i) {
        var p = propByKey(c.prop);
        if (i > 0) {
          var jrow = document.createElement('div');
          jrow.className = 'pim-fp__chip-row'; jrow.style.justifyContent = 'center';
          var j = document.createElement('button');
          j.className = 'pim-fp__join'; j.type = 'button';
          j.textContent = c.join === 'and' ? t('fp_join_and') : t('fp_join_or');
          j.title = t('fp_join_title');
          j.addEventListener('click', function () { c.join = c.join === 'and' ? 'or' : 'and'; activeSavedId = null; renderChips(); renderSaved(); apply(); });
          jrow.appendChild(j); elChips.appendChild(jrow);
        }
        var row = document.createElement('div'); row.className = 'pim-fp__chip-row';
        var chip = document.createElement('div'); chip.className = 'pim-fp__chip';
        var txt = document.createElement('span'); txt.className = 'pim-fp__chip-txt';
        txt.innerHTML = '<b>' + escapeHtml(p.label) + '</b> ' + escapeHtml(opLabel(p.type, c.op).toLowerCase()) +
          (c.hasVal ? ' <em>' + escapeHtml(c.valueDisp) + '</em>' : '');
        var x = document.createElement('button');
        x.className = 'pim-fp__chip-x'; x.type = 'button'; x.setAttribute('aria-label', t('fp_chip_remove_aria'));
        x.innerHTML = '<svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><line x1="5" y1="5" x2="19" y2="19"/><line x1="19" y1="5" x2="5" y2="19"/></svg>';
        x.addEventListener('click', function () {
          conditions.splice(i, 1);
          if (conditions[0]) conditions[0].join = null;
          activeSavedId = null;
          renderChips(); renderSaved(); apply();
        });
        chip.appendChild(txt); chip.appendChild(x); row.appendChild(chip); elChips.appendChild(row);
      });
    }

    function rowValue(row, key) {
      if (key === 'name') return (row.querySelector('.pim-name').textContent || '').toLowerCase();
      if (key === 'sku')  return (row.querySelector('.pim-sku').textContent || '').toLowerCase();
      if (key === 'complete') return row.dataset.complete || '';
      return '';
    }
    function matchOne(row, c) {
      var v = rowValue(row, c.prop);
      var cmp = (c.value || '').toString().toLowerCase();
      switch (c.op) {
        case 'contains': return v.indexOf(cmp) !== -1;
        case 'eq':       return v === cmp;
        case 'neq':      return v !== cmp;
        case 'has':      return v.length > 0;
        case 'empty':    return v.length === 0;
      }
      return true;
    }
    function matchConditions(row) {
      if (!conditions.length) return true;
      var res = matchOne(row, conditions[0]);
      for (var i = 1; i < conditions.length; i++) {
        var m = matchOne(row, conditions[i]);
        res = conditions[i].join === 'and' ? (res && m) : (res || m);
      }
      return res;
    }
    function matchSearch(row) {
      if (!searchTerm) return true;
      return rowValue(row, 'name').indexOf(searchTerm) !== -1 || rowValue(row, 'sku').indexOf(searchTerm) !== -1;
    }

    var emptyEl = null;
    function apply() {
      var visible = 0;
      rows.forEach(function (r) {
        var show = matchSearch(r) && matchConditions(r);
        r.classList.toggle('is-filtered', !show);
        if (show) visible++;
      });
      if (elCount) elCount.textContent = visible + ' / ' + rows.length;
      if (!emptyEl) {
        emptyEl = document.createElement('div');
        emptyEl.className = 'pim-empty';
        emptyEl.textContent = t('fp_empty');
        rowsWrap.appendChild(emptyEl);
      }
      emptyEl.classList.toggle('is-visible', visible === 0);
      lastVisible = visible;
      updateActiveBar();
    }
    function updateActiveBar() {
      var bar = document.getElementById('pim-active-bar');
      var active = conditions.length > 0 || !!searchTerm;
      if (filterBtn) filterBtn.classList.toggle('pim-icon-btn--filtered', active);
      if (!bar) return;
      if (!active || !panel.hidden) { bar.hidden = true; return; }
      var label = document.getElementById('pim-active-bar-label');
      var cnt = document.getElementById('pim-active-bar-count');
      var txt;
      if (activeSavedId) {
        var sf = savedFilters.filter(function (x) { return x.id === activeSavedId; })[0];
        txt = sf ? t('active_bar_saved_prefix') + sf.name : t('active_bar_label');
      } else if (conditions.length) {
        txt = conditions.length + ' ' + (conditions.length === 1 ? t('active_bar_condition') : t('active_bar_conditions'));
        if (searchTerm) txt += t('active_bar_plus_search');
      } else {
        txt = t('active_bar_search_prefix') + searchTerm + t('active_bar_search_suffix');
      }
      if (label) label.textContent = txt;
      if (cnt) cnt.textContent = lastVisible + ' / ' + rows.length;
      bar.hidden = false;
    }

    elProp.addEventListener('change', populateOps);
    elOp.addEventListener('change', renderValue);
    elAdd.addEventListener('click', addCondition);
    if (elSearch) elSearch.addEventListener('input', function () {
      searchTerm = this.value.trim().toLowerCase();
      if (elSearchX) elSearchX.hidden = this.value.length === 0;
      activeSavedId = null; renderSaved();
      apply();
    });
    if (elSearchX) elSearchX.addEventListener('click', function () {
      if (elSearch) { elSearch.value = ''; elSearch.focus(); }
      searchTerm = ''; elSearchX.hidden = true;
      activeSavedId = null; renderSaved(); apply();
    });

    function clearAll() {
      conditions = []; searchTerm = '';
      if (elSearch) elSearch.value = '';
      if (elSearchX) elSearchX.hidden = true;
      if (elSaveRow) elSaveRow.hidden = true;
      activeSavedId = null;
      renderChips(); renderSaved(); apply();
    }
    var clearBtn = document.getElementById('pim-fp-clear');
    if (clearBtn) clearBtn.addEventListener('click', clearAll);
    var activeClearBtn = document.getElementById('pim-active-bar-clear');
    if (activeClearBtn) activeClearBtn.addEventListener('click', clearAll);
    var activeEditBtn = document.getElementById('pim-active-bar-edit');
    if (activeEditBtn) activeEditBtn.addEventListener('click', function (e) { e.stopPropagation(); openPanel('builder'); });
    var applyBtn = document.getElementById('pim-fp-apply');
    if (applyBtn) applyBtn.addEventListener('click', function () { apply(); closePanel(); });
    var closeBtn = document.getElementById('pim-fp-close');
    if (closeBtn) closeBtn.addEventListener('click', closePanel);

    var saveBtn = document.getElementById('pim-fp-save');
    if (saveBtn) saveBtn.addEventListener('click', function () {
      if (!conditions.length && !searchTerm) return;
      if (!elSaveRow) return;
      elSaveRow.hidden = !elSaveRow.hidden;
      if (!elSaveRow.hidden && elSaveName) { elSaveName.value = ''; setTimeout(function () { elSaveName.focus(); }, 20); }
    });
    function commitSave() {
      if (!elSaveName) return;
      var name = (elSaveName.value || '').trim();
      if (!name) { elSaveName.focus(); return; }
      if (!conditions.length && !searchTerm) return;
      var f = { id: ++savedSeq, name: name, conditions: JSON.parse(JSON.stringify(conditions)), search: searchTerm };
      savedFilters.push(f);
      activeSavedId = f.id;
      elSaveRow.hidden = true; elSaveName.value = '';
      renderSaved();
    }
    var saveConfirm = document.getElementById('pim-fp-save-confirm');
    if (saveConfirm) saveConfirm.addEventListener('click', commitSave);
    if (elSaveName) elSaveName.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); commitSave(); } });

    function applySaved(f) {
      conditions = JSON.parse(JSON.stringify(f.conditions));
      searchTerm = f.search || '';
      if (elSearch) elSearch.value = searchTerm;
      if (elSearchX) elSearchX.hidden = searchTerm.length === 0;
      activeSavedId = f.id;
      renderChips(); renderSaved(); apply();
    }
    function turnOff() {
      conditions = []; searchTerm = '';
      if (elSearch) elSearch.value = '';
      if (elSearchX) elSearchX.hidden = true;
      activeSavedId = null;
      renderChips(); renderSaved(); apply();
    }
    function renderSaved() {
      if (!elSavedList) return;
      elSavedList.innerHTML = '';
      if (!savedFilters.length) { if (elSavedRow) elSavedRow.hidden = true; return; }
      if (elSavedRow) elSavedRow.hidden = false;
      savedFilters.forEach(function (f) {
        var pill = document.createElement('span');
        pill.className = 'pim-fp__saved-pill' + (f.id === activeSavedId ? ' pim-fp__saved-pill--active' : '');
        var ico = document.createElement('span');
        ico.className = 'pim-fp__saved-pill__ico';
        ico.innerHTML = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
        var nm = document.createElement('span');
        nm.className = 'pim-fp__saved-pill__name'; nm.textContent = f.name;
        nm.title = f.id === activeSavedId ? t('fp_saved_off_title') : t('fp_saved_apply_title');
        nm.addEventListener('click', function (e) { e.stopPropagation(); if (f.id === activeSavedId) turnOff(); else applySaved(f); });
        var del = document.createElement('button');
        del.className = 'pim-fp__saved-pill__del'; del.type = 'button'; del.setAttribute('aria-label', t('fp_saved_delete_aria'));
        del.innerHTML = '<svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><line x1="5" y1="5" x2="19" y2="19"/><line x1="19" y1="5" x2="5" y2="19"/></svg>';
        del.addEventListener('click', function (e) {
          e.stopPropagation();
          savedFilters = savedFilters.filter(function (x) { return x.id !== f.id; });
          if (activeSavedId === f.id) activeSavedId = null;
          renderSaved();
        });
        pill.appendChild(ico); pill.appendChild(nm); pill.appendChild(del); elSavedList.appendChild(pill);
      });
    }

    var filterBtn = document.getElementById('pim-filter-btn');
    var searchBtn = document.getElementById('pim-search-btn');
    function openPanel(focus) {
      var aiP = document.getElementById('pim-ai-panel'); if (aiP) aiP.hidden = true;
      var demoP = document.getElementById('pim-demo-panel'); if (demoP) demoP.hidden = true;
      var aiB = document.getElementById('pim-ai-btn'); if (aiB) aiB.classList.remove('is-on');
      panel.hidden = false;
      if (filterBtn) filterBtn.classList.add('is-active');
      if (focus === 'search' && elSearch) setTimeout(function () { elSearch.focus(); }, 40);
      updateActiveBar();
    }
    function closePanel() {
      panel.hidden = true;
      if (filterBtn) filterBtn.classList.remove('is-active');
      updateActiveBar();
    }
    if (filterBtn) filterBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (panel.hidden) openPanel('builder'); else closePanel();
    });
    if (searchBtn) searchBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (panel.hidden) openPanel('search'); else if (elSearch) elSearch.focus();
    });
    document.addEventListener('click', function (e) {
      if (panel.hidden) return;
      if (!document.body.contains(e.target)) return;
      if (e.target.closest('#pim-filter-panel')) return;
      if (e.target.closest('#pim-filter-btn') || e.target.closest('#pim-search-btn')) return;
      closePanel();
    });

    populateOps();
    renderChips();
    renderSaved();
    apply();
  })();

  (function () {
    function gid(id) { return document.getElementById(id); }
    var aiBtn      = gid('pim-ai-btn');
    var aiPanel    = gid('pim-ai-panel');
    var aiBody     = gid('pim-ai-body');
    var demoPanel  = gid('pim-demo-panel');
    var demoBody   = gid('pim-demo-body');
    var filterPanel = gid('pim-filter-panel');
    if (!aiPanel || !demoPanel) return;

    var GREETING = t('ai_greeting');
    var QA = [
      { q: t('ai_q1'), a: t('ai_a1') },
      { q: t('ai_q2'), a: t('ai_a2') },
      { q: t('ai_q3'), a: t('ai_a3') }
    ];
    var DEMO = {
      'link-categories': t('demo_phrase_link_categories'),
      'edit-properties': t('demo_phrase_edit_properties'),
      'export':          t('demo_phrase_export'),
      'link-relations':  t('demo_phrase_link_relations'),
      'link-tag':        t('demo_phrase_link_tag')
    };
    var ACTION_LABEL = {
      'link-categories': t('bulk_link_categories'),
      'edit-properties': t('bulk_edit_properties'),
      'export':          t('bulk_export'),
      'link-relations':  t('bulk_link_relations'),
      'link-tag':        t('bulk_link_tag')
    };

    var svgWave = '<svg style="display:inline;vertical-align:middle;margin:0 4px 2px 0" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/></svg>';
    var svgArrow = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';
    var svgSearch = '<svg style="display:inline;vertical-align:middle;margin:0 4px 2px 0" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>';

    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;' })[c]; }); }
    function aiMsg(c, html) { var m = document.createElement('div'); m.className = 'pim-ai__msg pim-ai__msg--ai'; var b = document.createElement('div'); b.className = 'pim-ai__bubble'; b.innerHTML = html; m.appendChild(b); c.appendChild(m); return m; }
    function userMsg(c, text) { var m = document.createElement('div'); m.className = 'pim-ai__msg pim-ai__msg--user'; var b = document.createElement('div'); b.className = 'pim-ai__bubble'; b.textContent = text; m.appendChild(b); c.appendChild(m); }
    function typing(c) { var e = document.createElement('div'); e.className = 'pim-ai__typing'; e.innerHTML = '<span></span><span></span><span></span>'; c.appendChild(e); return e; }
    function scrollC(c) { requestAnimationFrame(function () { requestAnimationFrame(function () { c.scrollTop = c.scrollHeight; }); }); }
    function ctaCard(c, label, heading, text) {
      var cta = document.createElement('div'); cta.className = 'pim-ai__cta';
      cta.innerHTML =
        '<div class="pim-ai__cta-label">' + esc(label) + '</div>' +
        '<div class="pim-ai__cta-heading">' + esc(heading) + '</div>' +
        '<div class="pim-ai__cta-text">' + esc(text) + '</div>' +
        '<a href="' + esc(L.demo_url || '#') + '" class="pim-ai__cta-btn">' + svgArrow + esc(t('demo_cta_button')) + '</a>';
      c.appendChild(cta);
    }

    function initChat() {
      aiBody.innerHTML = '';
      var greet = aiMsg(aiBody, svgWave + esc(GREETING));
      var chips = document.createElement('div'); chips.className = 'pim-ai__chips';
      QA.forEach(function (item) {
        var chip = document.createElement('button'); chip.type = 'button'; chip.className = 'pim-ai__chip'; chip.textContent = item.q;
        chip.addEventListener('click', function (e) {
          e.stopPropagation();
          chips.remove();
          userMsg(aiBody, item.q);
          var t1 = typing(aiBody); scrollC(aiBody);
          setTimeout(function () {
            t1.remove(); aiMsg(aiBody, esc(item.a)); scrollC(aiBody);
            var t2 = typing(aiBody); scrollC(aiBody);
            setTimeout(function () {
              t2.remove();
              aiMsg(aiBody, svgSearch + esc(t('ai_analysis')));
              ctaCard(aiBody, t('ai_cta_label'), t('ai_cta_heading'), t('ai_cta_text'));
              scrollC(aiBody);
            }, 1100);
          }, 1300);
        });
        chips.appendChild(chip);
      });
      greet.querySelector('.pim-ai__bubble').appendChild(chips);
      scrollC(aiBody);
    }

    function showDemo(action, phrase) {
      demoBody.innerHTML = '';
      userMsg(demoBody, action);
      var t1 = typing(demoBody); scrollC(demoBody);
      setTimeout(function () {
        t1.remove();
        aiMsg(demoBody, svgWave + esc(action) + esc(t('demo_reply_suffix')));
        ctaCard(demoBody, t('demo_cta_label'), t('demo_cta_heading_prefix') + phrase + t('demo_cta_heading_suffix'), t('demo_cta_text'));
        scrollC(demoBody);
      }, 900);
    }

    function hideAll() {
      if (filterPanel) filterPanel.hidden = true;
      aiPanel.hidden = true; if (aiBtn) aiBtn.classList.remove('is-on');
      demoPanel.hidden = true;
    }
    function openAI()  { hideAll(); aiPanel.hidden = false; if (aiBtn) aiBtn.classList.add('is-on'); initChat(); }
    function openDemo(action, phrase) { hideAll(); demoPanel.hidden = false; showDemo(action, phrase); }

    if (aiBtn) aiBtn.addEventListener('click', function (e) { e.stopPropagation(); if (aiPanel.hidden) openAI(); else { aiPanel.hidden = true; aiBtn.classList.remove('is-on'); } });
    var aiClose = gid('pim-ai-close'); if (aiClose) aiClose.addEventListener('click', function (e) { e.stopPropagation(); aiPanel.hidden = true; if (aiBtn) aiBtn.classList.remove('is-on'); });
    var demoClose = gid('pim-demo-close'); if (demoClose) demoClose.addEventListener('click', function (e) { e.stopPropagation(); demoPanel.hidden = true; });

    Array.prototype.forEach.call(document.querySelectorAll('.pim-bulk-option'), function (opt) {
      opt.addEventListener('click', function (e) {
        e.stopPropagation();
        var dd = gid('pim-bulk-dropdown'); if (dd) dd.classList.remove('is-open');
        var bb = gid('pim-bulk-btn'); if (bb) bb.classList.remove('is-open');
        var key = opt.getAttribute('data-action') || '';
        openDemo(ACTION_LABEL[key] || key, DEMO[key] || t('demo_phrase_fallback'));
      });
    });

    document.addEventListener('click', function (e) {
      if (aiPanel.hidden && demoPanel.hidden) return;
      if (!document.body.contains(e.target)) return;
      if (e.target.closest('#pim-ai-panel') || e.target.closest('#pim-demo-panel')) return;
      if (e.target.closest('#pim-ai-btn') || e.target.closest('.pim-bulk-option')) return;
      aiPanel.hidden = true; if (aiBtn) aiBtn.classList.remove('is-on');
      demoPanel.hidden = true;
    });
  })();

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
